import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import padStart from 'lodash/padStart'

import { Label, FormField, Select, theme } from 'pcln-design-system'

const minutes = ['00', '30']
const times = []
for (let i = 0; i < 48; i++) {
  times.push(i)
}

const timeOptions = times.map(time => {
  const h = Math.floor(time / 2)
  if (time === 0) {
    return { label: 'Midnight', value: `${padStart(h, 2, '0')}:00` }
  }
  if (time === 24) return { label: 'Noon', value: `${padStart(h, 2, '0')}:00` }
  const hour = h === 0 || h === 12 ? 12 : h % 12
  const minute = minutes[time % 2]
  const meridiem = h < 12 ? 'AM' : 'PM'
  const value = `${padStart(h, 2, '0')}:${minute}`
  return {
    key: value,
    label: `${hour}:${minute} ${meridiem}`,
    value: value
  }
})

const parseTimeOptions = () =>
  timeOptions.map(time => {
    const MIDNIGHT = 'Midnight'
    const NOON = 'Noon'
    const isMidnight = time.value === '00:00'
    const isNoon = time.value === '12:00'
    const parseTime = () =>
      parseInt(time.value) < 12 ? `${time.value} AM` : `${time.value} PM`
    const optionTimeValue = isMidnight ? MIDNIGHT : isNoon ? NOON : parseTime()
    return (
      <option key={time.value} {...time}>
        {optionTimeValue}
      </option>
    )
  })

const StyledSelect = styled(Select)`
  background: ${theme.colors.white};
  &::-ms-expand {
    display: none;
  }
  cursor: pointer;
`

const TimeField = ({ name, label, ...props }) => (
  <FormField>
    <Label autoHide>{label}</Label>
    <StyledSelect {...props} id={name} name={name}>
      {parseTimeOptions()}
    </StyledSelect>
  </FormField>
)

TimeField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired
}

export default TimeField
